import React from "react";
import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Col,
  Label,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import tutorsModal from "models/tutors.modal";

import { Link } from "react-router-dom";
import parentsModal from "models/parents.modal";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import EhcModel from "models/Ehc.model";
import Loader from "components/loader/Loader";
import { generateRandomStrings } from "lib/helper";

const EHC = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };
  const [totalpage, setTotalpage] = useState();
  const [teststatus, setTesttatus] = useState("");
  const [status, setStatus] = useState("?class_status=All");
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    // Use static data from EhcModel
    const result = await EhcModel.List(status, teststatus, parameters);
    setIsLoading(false);
    if (result) {
      console.log("result", result);
      setDataList(result);
      setTotalpage(result?.meta?.total_page);
      setCurrentPage(result?.meta?.current_page);
      setPerPage(result?.meta?.per_page);
      setIsDataFetched(generateRandomStrings(15));
    }
  };
  useEffect(() => {
    getListData();
  }, [currentPage]);
  const [alldata, setAlldata] = useState();
  const [holddata, setHolddata] = useState();
  const [activedata, setActivedata] = useState();
  const [Completeddata, setCompleteddata] = useState();
  const [discontinuddata, setDiscontinueddata] = useState();
  const [smedata, setSmedata] = useState();
  const [Separatedata, setSepratedata] = useState();
  const [combineddata, setCombineddata] = useState();

  const getListDatacount = async () => {
    try {
      const allResult = await EhcModel.Listcount("?class_status=All");
      setAlldata(allResult?.count);

      const activeResult = await EhcModel.Listcount("?class_status=Active");
      setActivedata(activeResult?.count);

      const holdResult = await EhcModel.Listcount("?class_status=Hold");
      setHolddata(holdResult?.count);

      const completedResult = await EhcModel.Listcount(
        "?class_status=Completed"
      );
      setCompleteddata(completedResult?.count);

      const discontinuedResult = await EhcModel.Listcount(
        "?class_status=Discontinued"
      );
      setDiscontinueddata(discontinuedResult?.count);

      const combinedResult = await EhcModel.Listcount("?class_type=COMBINED");
      setCombineddata(combinedResult?.count);

      const smeResult = await EhcModel.Listcount("?class_type=SME");
      setSmedata(smeResult?.count);

      const separateResult = await EhcModel.Listcount("?class_type=SEPARATE");
      setSepratedata(separateResult?.count);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    getListData();
    getListDatacount();
  }, [location]);
  useEffect(() => {
    getListData();
  }, [status, teststatus]);
  console.log("lenght of ech", alldata);
  useEffect(() => {
    const fetchStudentSubjects = async () => {
      if (dataList?.data?.studentData) {
        const updatedDataList = { ...dataList };
        const studentDataPromises = updatedDataList.data.studentData.map(
          async (studentItem) => {
            const studentSubjects = await parentsModal.StudentSubjectList(
              studentItem?.id
            );
            return {
              ...studentItem,
              subjectList: studentSubjects?.data?.Subjects || [],
            };
          }
        );

        const updatedStudentData = await Promise.all(studentDataPromises);
        updatedDataList.data.studentData = updatedStudentData;
        setDataList(updatedDataList);
      }
    };
    //fetchStudentSubjects();
  }, [isDataFetched]);

  // console.log(dataList, "dataListparentlist");

  const tableRef = useRef(null);
  const downloadPDF = () => {
    const input = tableRef.current;

    if (!input) {
      console.error("Table element not found.");
      return;
    }

    // Hide action column before capturing the table

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const width = pdf.internal.pageSize.getWidth();
        const height = (canvas.height * width) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, width, height);
        pdf.save("tutors_list.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-center">
                <span className="mb-2 mb-md-0">All EHC</span>

                <div className="d-flex flex-row"></div>
              </CardHeader>

              <Row className="mt-2 ">
                <Col md={12} className="">
                  <div className="d-flex mb-2 px-4 justify-content-between">
                    <div className="d-flex">
                      <span
                        style={{
                          color:
                            status == "?class_status=All" ? "blue" : "black",

                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_status=All");
                        }}
                      >
                        All (
                        <span
                          style={{
                            color:
                              status == "?class_status=All" ? "black" : "blue",
                          }}
                        >
                          {alldata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_status=Hold" ? "blue" : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_status=Hold");
                        }}
                      >
                        Hold (
                        <span
                          style={{
                            color:
                              status == "?class_status=Hold" ? "black" : "blue",
                          }}
                        >
                          {holddata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_status=Active" ? "blue" : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_status=Active");
                        }}
                      >
                        Active (
                        <span
                          style={{
                            color:
                              status == "?class_status=Active"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {activedata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_status=Completed"
                              ? "blue"
                              : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_status=Completed");
                        }}
                      >
                        Completed (
                        <span
                          style={{
                            color:
                              status == "?class_status=Completed"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {Completeddata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_status=Discontinued"
                              ? "blue"
                              : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_status=Discontinued");
                        }}
                      >
                        Discontinued (
                        <span
                          style={{
                            color:
                              status == "?class_status=Discontinued"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {discontinuddata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color: status == "?class_type=SME" ? "blue" : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_type=SME");
                        }}
                      >
                        SME (
                        <span
                          style={{
                            color:
                              status == "?class_type=SME" ? "black" : "blue",
                          }}
                        >
                          {smedata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_type=SEPARATE" ? "blue" : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_type=SEPARATE");
                        }}
                      >
                        Separate Class (
                        <span
                          style={{
                            color:
                              status == "?class_type=SEPARATE"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {Separatedata?.length}
                        </span>
                        )
                      </span>
                      <span
                        style={{
                          color:
                            status == "?class_type=COMBINED" ? "blue" : "black",
                          marginLeft: "20px",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setStatus("?class_type=COMBINED");
                        }}
                      >
                        Combined Class (
                        <span
                          style={{
                            color:
                              status == "?class_type=COMBINED"
                                ? "black"
                                : "blue",
                          }}
                        >
                          {combineddata?.length}
                        </span>
                        )
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <Label
                        style={{
                          marginRight: "10px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Test Status
                      </Label>
                      <Input
                        type="select"
                        onChange={(e) => {
                          setTesttatus(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        <option value="&ehc_test_status=conducted">
                          Conducted
                        </option>
                        <option value="&ehc_test_status=not_conducted">
                          Not Conducted
                        </option>
                      </Input>
                    </div>
                  </div>
                  <div
                    ref={tableRef}
                    style={{ maxWidth: "100%", overflowX: "auto" }}
                  >
                    <Table
                      className="align-items-center table-flush "
                      responsive
                    >
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">S.NO</th>
                          <th scope="col">
                            Parent
                            <br />
                            Name & Mobile
                          </th>
                          <th scope="col">Class</th>
                          <th scope="col">
                            Educator
                            <br />
                            Name & Mobile
                          </th>
                          <th scope="col">Invegilator Date & Time</th>
                          <th scope="col">
                            Discovery
                            <br />
                            Call
                            <br />
                            Status
                          </th>
                          <th scope="col">
                            Discovery
                            <br />
                            Call
                            <br />
                            Date
                          </th>
                          <th scope="col">Location</th>
                          <th scope="col">
                            Last
                            <br />
                            EHC
                            <br />
                            Date
                          </th>
                          <th scope="col">
                            Last
                            <br />
                            SRC
                            <br />
                            Date
                          </th>
                          <th scope="col">
                            Class
                            <br />
                            Status
                          </th>
                          <th scope="col">
                            EHC
                            <br />
                            Test
                            <br />
                            Status
                          </th>
                          <th scope="col">
                            EHC Manager
                            <br />
                            Name & Mobile
                          </th>
                          <th scope="col">
                            Class
                            <br />
                            Remaining %
                          </th>
                          {/* <th scope="col">Action</th>*/}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <td
                              colSpan={14}
                              className="text-center align-middle w-full"
                            >
                              Please wait...
                              <Loader />
                            </td>
                          </tr>
                        ) : dataList?.data?.length > 0 ? (
                          <>
                            {dataList?.data?.map((ehcItem, index) => {
                              console.log("trry", ehcItem);
                              return (
                                <tr key={`ehc${index}`}>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.s_no || index + 1}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    <Link
                                      to={`/admin/ehc/viewehc/${ehcItem?.id}`}
                                    >
                                      {ehcItem?.parent_name}
                                      <br />
                                      {ehcItem?.parent_mobile}
                                    </Link>
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.class}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.educator_name}
                                    <br />
                                    {ehcItem?.educator_mobile}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.invigilator_date_time}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.discovery_call_status}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.discovery_call_date}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.location}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.last_ehc_date}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.last_src_date}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.class_status}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.test_status}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.ehc_manager_name}
                                    <br />
                                    {ehcItem?.ehc_manager_mobile}
                                  </td>
                                  <td style={{ padding: "0.2rem" }}>
                                    {ehcItem?.class_remaining_percentage}%
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td
                              colSpan="14"
                              style={{ textAlign: "center", padding: "1rem" }}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                      {/* <tr className="h-30vh">
                            <td>1</td>
                            <td>Pawan Singh 9302687403</td>
                            <td>Academic/Sub1/Sub2</td>
                            <td>Santosh Sharma (7676767676)</td>
                            <td>12/12/2022 0:49:00 </td>
                            <td>Done</td>
                            <td>112/12/2022 0:49:00</td>
                            <td>Bhopal</td>
                            <td>12/12/2022</td>
                            <td>12/12/2022</td>
                            <td>Active </td>
                            <td>EHC Scheduled</td>
                            <td>Santosh Sharma (7676767676)</td>
                            <td>24% (13/25)</td>
                            <td
                              className="p-0 pr-4"
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "20px",
                              }}
                            >
                              <UncontrolledTooltip
                                placement="top"
                                target="eyeTooltip"
                              >
                                View
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="eyeTooltip"
                                to={`/admin/ehc/viewehc/${"1"}/${"2"}`}
                              // tag={Link}
                              >
                                <i class="fa-solid fa-eye"></i>
                              </Link>
                            </td>
                          </tr> */}
                    </Table>
                  </div>
                </Col>
              </Row>

              <CardFooter className="py-4">
                <TablePagination
                  totalPages={totalpage}
                  currentPage={currentPage}
                  pageUrl="/admin/ehc?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </div>
    </>
  );
};

export default EHC;
